var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"custom-button",class:[_vm.customClass, _vm.variant, { disabled: _vm.disabled, 'with-icon': _vm.icon }],on:{"click":function($event){return _vm.onButtonClick($event)}}},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.icon)?_c('img',{staticClass:"icon",attrs:{"src":`assets/images/icons/${_vm.icon}.svg`}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }